<template>
  <div id="error" class="section">
    <h2>
      <span class="section-title">Error</span>
      <span class="section-description">{{ $route.query.title }}</span>
    </h2>
    <hr>
    <div v-if="$route.query.msg">
      <p v-text="$route.query.msg" class="has-text-weight-bold margin-bottom-30px"></p>
    </div>
    <p v-else class="has-text-weight-bold">{{ $t('error.error') }}</p>
    <div class="margin-top-30px">
      <Subscription v-if="$route.query.is_modal !== '' && $route.query.is_modal"></Subscription>
    </div>
  </div>
</template>

<script>
import {defineAsyncComponent} from 'vue'
import {useHead} from "@unhead/vue";
import appConfig from "../app.config.json";

export default {
  name: 'Error',
  components: {
    Subscription: defineAsyncComponent(() => import('../components/SubscriptionComponent.vue'))
  },
  created() {
    useHead({
      title: `${this.$t('error.title')} | ${appConfig[this.$i18n.locale].title}`,
      meta: [
        {name: 'description', content: appConfig[this.$i18n.locale].description.top},
        {name: 'robots', content: 'noindex,nofollow'}
      ]
    })
  }
}
</script>

<style lang="scss" scoped>
</style>
